/* ============================================================
   Collection Filter Drawer — INSAURA  |  Sprint 4
   Client-side filtering. Grid updates on Apply only.
   Desktop: sidebar always open. Mobile: slide-in drawer.
   ============================================================ */
(function () {
  'use strict';

  var drawer      = document.getElementById('CollFilterDrawer');
  if (!drawer) return;

  var backdrop    = drawer.querySelector('.cfdr__backdrop');
  var closeBtn    = drawer.querySelector('.cfdr__close');
  var applyBtn    = document.getElementById('CfdrApply');
  var clearAllBtn = document.getElementById('CfdrClearAll');
  var countEl     = document.getElementById('CfdrCount');
  var rangeMin    = document.getElementById('CfdrRangeMin');
  var rangeMax    = document.getElementById('CfdrRangeMax');
  var priceMinEl  = document.getElementById('CfdrPriceMin');
  var priceMaxEl  = document.getElementById('CfdrPriceMax');
  var rangeFill   = document.getElementById('CfdrRangeFill');
  var pillsBar    = document.getElementById('CfdrPillsBar');
  var allChecks   = drawer.querySelectorAll('.cfdr__check');

  var globalPriceMin = rangeMin ? parseFloat(rangeMin.min) : 0;
  var globalPriceMax = rangeMax ? parseFloat(rangeMax.max) : 9999;

  /* ── Viewport helper ──────────────────────────────────────── */
  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  /* ── Open / Close ──────────────────────────────────────────── */
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('cfdr--open');
    document.body.classList.add('cfdr-body-locked');
    refreshCount();
  }

  function closeDrawer() {
    if (isDesktop()) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('cfdr--open');
    document.body.classList.remove('cfdr-body-locked');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('cfdr--open')) closeDrawer();
  });

  /* On resize to desktop: release any scroll lock */
  window.addEventListener('resize', function () {
    if (isDesktop()) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.remove('cfdr-body-locked');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  });

  /* Expose to collection-header.js */
  window.collFilterDrawer = { open: openDrawer, close: closeDrawer };

  /* ── Product items ─────────────────────────────────────────── */
  function getProducts() {
    var grid = document.getElementById('product-grid');
    return grid ? Array.from(grid.querySelectorAll('li[data-cfdr-notes]')) : [];
  }

  /* ── Build filter state ────────────────────────────────────── */
  function getFilters() {
    var f = { note: [], location: [], timeofday: [], season: [], gender: [], brand: [], shop_by: [] };
    allChecks.forEach(function (check) {
      if (check.checked) {
        var type = check.dataset.filterType;
        if (f[type]) f[type].push(check.value.toLowerCase().trim());
      }
    });
    if (rangeMin && rangeMax) {
      f.priceMin    = parseFloat(rangeMin.value);
      f.priceMax    = parseFloat(rangeMax.value);
      f.priceActive = f.priceMin > globalPriceMin || f.priceMax < globalPriceMax;
    } else {
      f.priceActive = false;
      f.priceMin    = globalPriceMin;
      f.priceMax    = globalPriceMax;
    }
    return f;
  }

  /* ── Comma-list helper ─────────────────────────────────────── */
  function toList(str) {
    return (str || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  /* ── Match one product ─────────────────────────────────────── */
  function productMatches(li, filters) {
    var isEmpty = filters.note.length === 0 && filters.location.length === 0 &&
                  filters.timeofday.length === 0 && filters.season.length === 0 &&
                  filters.gender.length === 0 && filters.brand.length === 0 &&
                  filters.shop_by.length === 0 &&
                  !filters.priceActive;
    if (isEmpty) return true;

    var notes     = toList(li.dataset.cfdrNotes);
    var occasions = toList(li.dataset.cfdrOccasions);
    var seasons   = toList(li.dataset.cfdrSeasons);
    var tods      = toList(li.dataset.cfdrTimeofday);
    var gender    = (li.dataset.cfdrGender || '').toLowerCase().trim();
    var brand     = (li.dataset.cfdrBrand  || '').toLowerCase().trim();
    var price     = parseFloat(li.dataset.cfdrPrice  || '0');

    if (filters.note.length > 0) {
      if (!filters.note.some(function (n) { return notes.indexOf(n) !== -1; })) return false;
    }
    if (filters.location.length > 0) {
      if (!filters.location.some(function (o) { return occasions.indexOf(o) !== -1; })) return false;
    }
    if (filters.season.length > 0) {
      if (!filters.season.some(function (s) { return seasons.indexOf(s) !== -1; })) return false;
    }
    if (filters.timeofday.length > 0) {
      if (!filters.timeofday.some(function (t) { return tods.indexOf(t) !== -1; })) return false;
    }
    if (filters.gender.length > 0) {
      /* Selecting "Men" also includes Unisex products */
      var effectiveGenders = filters.gender.slice();
      if (effectiveGenders.indexOf('men') !== -1 && effectiveGenders.indexOf('unisex') === -1) {
        effectiveGenders.push('unisex');
      }
      if (effectiveGenders.indexOf(gender) === -1) return false;
    }
    if (filters.brand.length > 0) {
      if (filters.brand.indexOf(brand) === -1) return false;
    }
    if (filters.shop_by.length > 0) {
      var shopby = toList(li.dataset.cfdrShopby);
      if (!filters.shop_by.some(function (s) { return shopby.indexOf(s) !== -1; })) return false;
    }
    if (filters.priceActive) {
      if (price < filters.priceMin || price > filters.priceMax) return false;
    }
    return true;
  }

  /* ── Live count (while selecting — no grid update) ─────────── */
  function refreshCount() {
    var products = getProducts();
    var filters  = getFilters();
    var count    = products.filter(function (p) { return productMatches(p, filters); }).length;
    if (countEl) countEl.textContent = count + ' result' + (count !== 1 ? 's' : '');
  }

  /* ── Badge counts on group headers ────────────────────────── */
  function updateGroupBadges() {
    /* Per-group badges */
    drawer.querySelectorAll('[data-group]').forEach(function (badge) {
      var group = badge.dataset.group;
      if (group === 'price') return; /* handled separately */
      var n = drawer.querySelectorAll(
        '.cfdr__check[data-filter-group="' + group + '"]:checked'
      ).length;
      badge.hidden      = n === 0;
      badge.textContent = n > 0 ? '(' + n + ')' : '';
    });

    /* Parent badges — count all checked inside that <details> */
    drawer.querySelectorAll('[data-group-parent]').forEach(function (badge) {
      var parentDetails = badge.closest('details');
      var n = parentDetails ? parentDetails.querySelectorAll('.cfdr__check:checked').length : 0;
      badge.hidden      = n === 0;
      badge.textContent = n > 0 ? '(' + n + ')' : '';
    });

    /* Price badge */
    var priceBadge = drawer.querySelector('[data-group="price"]');
    if (priceBadge && rangeMin && rangeMax) {
      var active = parseFloat(rangeMin.value) > globalPriceMin ||
                   parseFloat(rangeMax.value) < globalPriceMax;
      priceBadge.hidden      = !active;
      priceBadge.textContent = active ? '(1)' : '';
    }
  }

  allChecks.forEach(function (check) {
    check.addEventListener('change', function () {
      updateGroupBadges();
      refreshCount();
    });
  });

  /* ── Price slider ──────────────────────────────────────────── */
  function updateRangeFill() {
    if (!rangeMin || !rangeMax || !rangeFill) return;
    var min    = parseFloat(rangeMin.min);
    var max    = parseFloat(rangeMax.max);
    var valMin = parseFloat(rangeMin.value);
    var valMax = parseFloat(rangeMax.value);
    var pctMin = ((valMin - min) / (max - min)) * 100;
    var pctMax = ((valMax - min) / (max - min)) * 100;
    rangeFill.style.left  = pctMin + '%';
    rangeFill.style.right = (100 - pctMax) + '%';
  }

  function onRangeInput(isMinSlider) {
    if (!rangeMin || !rangeMax) return;
    var min = parseFloat(rangeMin.value);
    var max = parseFloat(rangeMax.value);
    /* Prevent crossing */
    if (min > max) {
      if (isMinSlider) { rangeMin.value = max; min = max; }
      else             { rangeMax.value = min; max = min; }
    }
    if (priceMinEl) priceMinEl.textContent = '$' + Math.round(min);
    if (priceMaxEl) priceMaxEl.textContent = '$' + Math.round(max);
    updateRangeFill();
    updateGroupBadges();
    refreshCount();
  }

  if (rangeMin) rangeMin.addEventListener('input', function () { onRangeInput(true); });
  if (rangeMax) rangeMax.addEventListener('input', function () { onRangeInput(false); });

  /* ── Apply filters to DOM ──────────────────────────────────── */
  function applyFilters() {
    var products = getProducts();
    var filters  = getFilters();
    products.forEach(function (li) {
      li.style.display = productMatches(li, filters) ? '' : 'none';
    });
    renderExternalPills(filters);
    /* Re-bind any ADD TO CART triggers that may have missed initial binding */
    if (typeof window.insauraQsRebind === 'function') window.insauraQsRebind();
  }

  applyBtn.addEventListener('click', function () {
    applyFilters();
    if (!isDesktop()) closeDrawer();
  });

  /* ── Clear all ─────────────────────────────────────────────── */
  function clearAll() {
    allChecks.forEach(function (c) { c.checked = false; });
    if (rangeMin) rangeMin.value = globalPriceMin;
    if (rangeMax) rangeMax.value = globalPriceMax;
    if (priceMinEl) priceMinEl.textContent = '$' + Math.round(globalPriceMin);
    if (priceMaxEl) priceMaxEl.textContent = '$' + Math.round(globalPriceMax);
    updateRangeFill();
    updateGroupBadges();
    refreshCount();
  }

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function () {
      clearAll();
      applyFilters();
    });
  }

  /* ── External pills bar ────────────────────────────────────── */
  function renderExternalPills(filters) {
    if (!pillsBar) return;

    var pills = [];
    allChecks.forEach(function (check) {
      if (check.checked) {
        pills.push({ type: check.dataset.filterType, val: check.value });
      }
    });
    if (filters && filters.priceActive) {
      pills.push({
        type: 'price',
        val:  '$' + Math.round(filters.priceMin) + ' – £' + Math.round(filters.priceMax)
      });
    }

    if (pills.length === 0) {
      pillsBar.hidden    = true;
      pillsBar.innerHTML = '';
      return;
    }

    pillsBar.hidden = false;
    var html = pills.map(function (p) {
      return '<button class="cfdr-ext-pill" type="button"' +
        ' data-pill-type="' + p.type + '"' +
        ' data-pill-val="' + encodeURIComponent(p.val) + '">' +
        escapeHtml(p.val) + ' <span aria-hidden="true">&times;</span></button>';
    }).join('');
    html += '<button class="cfdr-ext-clear" type="button">Clear all</button>';
    pillsBar.innerHTML = html;

    pillsBar.querySelectorAll('.cfdr-ext-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var type = pill.dataset.pillType;
        var val  = decodeURIComponent(pill.dataset.pillVal);
        if (type === 'price') {
          if (rangeMin) rangeMin.value = globalPriceMin;
          if (rangeMax) rangeMax.value = globalPriceMax;
          onRangeInput(true);
        } else {
          var check = drawer.querySelector(
            '.cfdr__check[data-filter-type="' + type + '"][value="' + val + '"]'
          );
          if (check) check.checked = false;
        }
        updateGroupBadges();
        refreshCount();
        applyFilters();
      });
    });

    var extClearBtn = pillsBar.querySelector('.cfdr-ext-clear');
    if (extClearBtn) {
      extClearBtn.addEventListener('click', function () {
        clearAll();
        applyFilters();
      });
    }
  }

  /* ── HTML escape helper ────────────────────────────────────── */
  function escapeHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Dynamic sidebar top — stays below sticky header ─────────── */
  function updateSidebarTop() {
    if (!isDesktop()) return;
    var panel  = drawer.querySelector('.cfdr__panel');
    var header = document.querySelector('.section-header');
    var grid   = document.querySelector('.cfdr-grid-outer');
    if (!panel || !header) return;

    var topPx = Math.max(0, header.getBoundingClientRect().bottom);
    panel.style.top = topPx + 'px';

    // Clamp height so the panel never extends past the bottom of the product grid.
    var maxH = window.innerHeight - topPx;
    if (grid) {
      var gridBottom = grid.getBoundingClientRect().bottom;
      maxH = Math.min(maxH, Math.max(0, gridBottom - topPx));
    }
    panel.style.height = maxH + 'px';
  }

  /* ── Init ──────────────────────────────────────────────────── */
  function init() {
    updateRangeFill();
    refreshCount();
    updateSidebarTop();
    /* On desktop, mark drawer as accessible immediately */
    if (isDesktop()) {
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  window.addEventListener('scroll', updateSidebarTop, { passive: true });
  window.addEventListener('resize', updateSidebarTop, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Nav deep-link: pre-select filters from URL params ─── */
  /*
   * Supported params:
   *   ?cfdr_accord=fruity|sweet|woody|spicy  → opens Scent Accords + matching subgroup
   *   ?cfdr_occasion=Date+Night|Office|…     → pre-checks occasion checkbox + applies
   *   ?cfdr_gender=Men|Unisex                → pre-checks gender checkbox + applies
   */
  (function () {
    var p       = new URLSearchParams(window.location.search);
    var accord   = p.get('cfdr_accord');
    var occasion = p.get('cfdr_occasion');
    var season   = p.get('cfdr_season');
    var timeofday = p.get('cfdr_timeofday');
    var gender   = p.get('cfdr_gender');
    var brand    = p.get('cfdr_brand');
    var shop_by  = p.get('cfdr_shop_by');
    var note     = p.get('cfdr_note');
    if (!accord && !occasion && !season && !timeofday && !gender && !brand && !shop_by && !note) return;

    function activateFromUrl() {
      var didCheck = false;

      /* ── Accord: open Scent Accords group + subgroup ── */
      if (accord) {
        var accordLower = accord.toLowerCase();
        /* Find the subgroup whose data-group matches the accord param */
        var subgroupBadge = drawer.querySelector('[data-group="' + accordLower + '"]');
        if (subgroupBadge) {
          var subgroupDetails = subgroupBadge.closest('.cfdr__subgroup');
          if (subgroupDetails) {
            var parentGroup = subgroupDetails.closest('.cfdr__group');
            if (parentGroup) parentGroup.open = true;
            subgroupDetails.open = true;
          }
        }
      }

      /* ── Occasion: check matching checkbox ── */
      if (occasion) {
        var oLower = occasion.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'location' &&
              check.value.toLowerCase() === oLower) {
            check.checked = true;
            didCheck = true;
            /* Open parent Experience group + Occasions subgroup */
            var subg = check.closest('.cfdr__subgroup');
            if (subg) {
              var pg = subg.closest('.cfdr__group');
              if (pg) pg.open = true;
              subg.open = true;
            }
          }
        });
      }

      /* ── Season: check matching checkbox ── */
      if (season) {
        var sLower = season.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'season' &&
              check.value.toLowerCase() === sLower) {
            check.checked = true;
            didCheck = true;
            var subg = check.closest('.cfdr__subgroup');
            if (subg) {
              var pg = subg.closest('.cfdr__group');
              if (pg) pg.open = true;
              subg.open = true;
            } else {
              var pg2 = check.closest('.cfdr__group');
              if (pg2) pg2.open = true;
            }
          }
        });
      }

      /* ── Time of day: check matching checkbox ── */
      if (timeofday) {
        var todLower = timeofday.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'timeofday' &&
              check.value.toLowerCase() === todLower) {
            check.checked = true;
            didCheck = true;
            var subg = check.closest('.cfdr__subgroup');
            if (subg) {
              var pg = subg.closest('.cfdr__group');
              if (pg) pg.open = true;
              subg.open = true;
            } else {
              var pg2 = check.closest('.cfdr__group');
              if (pg2) pg2.open = true;
            }
          }
        });
      }

      /* ── Gender: check matching checkbox ── */
      if (gender) {
        var gLower = gender.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'gender' &&
              check.value.toLowerCase() === gLower) {
            check.checked = true;
            didCheck = true;
            var pg = check.closest('.cfdr__group');
            if (pg) pg.open = true;
          }
        });
      }

      /* ── Brand: check matching checkbox ── */
      if (brand) {
        var bLower = brand.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'brand' &&
              check.value.toLowerCase() === bLower) {
            check.checked = true;
            didCheck = true;
            var pg = check.closest('.cfdr__group');
            if (pg) pg.open = true;
          }
        });
      }

      /* ── Shop By: check matching checkbox ── */
      if (shop_by) {
        var sbLower = shop_by.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'shop_by' &&
              check.value.toLowerCase() === sbLower) {
            check.checked = true;
            didCheck = true;
            var pg = check.closest('.cfdr__group');
            if (pg) pg.open = true;
          }
        });
      }

      /* ── Note (individual fragrance note from PDP): check matching checkbox ── */
      if (note) {
        var nLower = note.toLowerCase();
        allChecks.forEach(function (check) {
          if (check.dataset.filterType === 'note' &&
              check.value.toLowerCase() === nLower) {
            check.checked = true;
            didCheck = true;
            /* Open parent Scent Accords group + relevant subgroup */
            var subg = check.closest('.cfdr__subgroup');
            if (subg) {
              var pg = subg.closest('.cfdr__group');
              if (pg) pg.open = true;
              subg.open = true;
            }
          }
        });
      }

      /* Apply filter + update UI */
      if (didCheck) {
        applyFilters();
        updateGroupBadges();
        refreshCount();
      }

      /* Open drawer on mobile */
      if (!isDesktop()) {
        openDrawer();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activateFromUrl);
    } else {
      activateFromUrl();
    }
  }());

})();
